import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { put } from "../../helpers/api_helper";
import { USER_UPDATE } from "../../helpers/url_helper";
import toastr from "toastr";

const EditUserModal = ({ isOpen, toggle, customerData, onUpdated }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      phone: "",
      name: "",
      email: "",
      status: "1",
    },
  });

  useEffect(() => {
    if (customerData) {
      reset(customerData);
    }
  }, [customerData, reset]);

  const onSubmit = async (data) => {
    try {
      await put(USER_UPDATE(customerData.ul_id), data); // ULID is passed here
      toastr.success("User updated successfully!");
      toggle(); // Close modal
      onUpdated(); // Refresh list
    } catch (error) {
      console.error("Error updating user", error);
      toastr.error("Failed to update customer.");
    }
  };
  const roles = [
    { label: "Admin", value: 1 },
    { label: "Accountant", value: 3 },
  ];
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Edit User</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md="6" xl="4">
              <div className="mb-3">
                <Label htmlFor="phone">
                  Phone No <span className="text-danger">*</span>
                </Label>
                <Controller
                  name="phone"
                  control={control}
                  rules={{
                    required: "Phone number is required",
                    pattern: {
                      value: /^[0-9]*$/, // only numbers
                      message: "Please enter only numbers",
                    },
                    minLength: {
                      value: 10,
                      message: "Must be 10-digits phone number",
                    },
                    maxLength: {
                      value: 10,
                      message: "Must be 10-digits phone number",
                    },
                  }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      id="phone"
                      placeholder="Enter Phone no"
                      type="tel" // opens phone's dial pad
                      inputMode="numeric" // fallback to show numeric keyboard
                      pattern="[0-9]*"
                      maxLength="10"
                      onKeyDown={(e) => {
                        // block non-digits
                        if (
                          !/[0-9]|Backspace|ArrowLeft|ArrowRight|Tab|Delete/.test(
                            e.key
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      className={`form-control ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                    />
                  )}
                />

                {errors.phone && (
                  <div className="text-danger">{errors.phone.message}</div>
                )}
              </div>
            </Col>
            <Col md="6" xl="4">
              <div className="mb-3 position-relative">
                <Label className="form-label" htmlFor="validationTooltip03">
                  Email
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                      message: "Invalid email format",
                    },
                  }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="text"
                      className={`form-control ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      id="email"
                      placeholder="Enter Email"
                    />
                  )}
                />
                {errors.email?.message && (
                  <div className="text-danger">{errors.email.message}</div>
                )}
              </div>
            </Col>

            <Col md="6" xl="4">
              <div className="mb-3">
                <Label htmlFor="name">Name</Label>
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: "Name is required" }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="text"
                      id="name"
                      placeholder="Enter name"
                    />
                  )}
                />
              </div>
            </Col>

            <Col md="6" xl="4">
              <div className="mb-3">
                <Label htmlFor="Password">Password</Label>
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="password"
                      placeholder="Enter Password"
                    />
                  )}
                />
              </div>
            </Col>

            <Col md="6" xl="4">
              <div className="mb-3">
                <Label htmlFor="customer_status">status</Label>
                <Controller
                  name="status"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Input
                      type="select"
                      {...field}
                      id="customer_status"
                      className="form-select"
                    >
                      <option value="">Select Status</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </Input>
                  )}
                />
              </div>
            </Col>
            <Col md="6" xl="4">
              <div className="mb-3 position-relative">
                <Label className="form-label">Role</Label>
                <Controller
                  name="role"
                  control={control}
                  rules={{
                    required: "Role is required",
                  }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="select"
                      className={`form-control ${
                        errors.role ? "is-invalid" : ""
                      }`}
                      id="role"
                      placeholder="Select Role"
                    >
                      <option key="" value="">
                        Select role
                      </option>
                      {roles.map((role) => (
                        <option
                          key={role.value}
                          value={role.value}
                          selected={customerData.role === role.value}
                        >
                          {role.label}
                        </option>
                      ))}
                    </Input>
                  )}
                />
                {errors?.role?.message && (
                  <div className="text-danger">{errors?.role.message}</div>
                )}
              </div>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <Button color="secondary" onClick={toggle} className="me-2">
              Cancel
            </Button>
            <Button color="primary" type="submit">
              Update
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default EditUserModal;
